// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IS8yB","container--boletim":"styles_container--boletim__2Kjz1","skeleton-animation":"styles_skeleton-animation__NPChn"};